import React, { useMemo, useState } from "react";
import './IEEEPage.css';
import Footer from "../components/Footer";
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import Navbar from "../components/navbar";
import PageHeader from "../about/PageHeader";

const yearsData = [
    {
        yearKey: "2024-2025",
        cards: [
            {
                header: { year: "FDP 2025", title: "Faculty Development Program" },
                sections: [
                    { h3: "Healthcare Technology & MATLAB", p: "TIMSCDR organized two days Faculty Development Program (FDP) between 6th to 10th January, 2025 as a transformative initiative fostering innovation and expertise in healthcare technology using MATLAB, in association with CSI, Mumbai Chapter." },
                    { h3: "Sessions & Experts", p: "The program opened with Mr. Vivek Lolitkar (IoT Presales, TCS) on molecular structures for disease prediction and AI's role in personalized treatments and ethics; Days 2-3 delivered deep dives into Deep Learning with MATLAB by Mr. Kunal Khandelwal (Application Engineer, MathWorks); Dr. Sabyasachi Sengupta (Ophthalmologist) shared practical ML impacts and automation; Day 5 concluded with a keynote by Dr. Suresh Shan on healthcare innovation, followed by faculty presentations and a Valedictory Function." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_3_CSI-pamphlet.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_4_CSI-1-1.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_5_CSI-3-1.webp"
                ]
            },
            {
                header: { year: "ICAIM 2024/2025", title: "International Conference" },
                sections: [
                    { h3: "Conference & Theme", p: "TIMSCDR organized ICAIM 2025 (International Conference on Advances in Information Technology and Management) conducted 10-11 February 2024 with theme Leveraging Information Technology for Sustainability in Agriculture and Healthcare - Women Empowerment." },
                    { h3: "Associations & Mode", p: "Arranged in association with AMC (Association of Medical Consultants), MACCIA (Maharashtra Chamber of Commerce, Industry and Agriculture), and Nordic Center for Sustainable Healthcare (NCSH); ICAIM 2024 ran in blended mode with eminent participation across IT, Agriculture, and Medicine." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_50_ICAIM-1-scaled.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_51_ICAIM-3-scaled.webp"
                ]
            },
            {
                header: { year: "VISTA 2025", title: "20th Anniversary Edition" },
                sections: [
                    { h3: "Qala Innovista Theme", p: "TIMSCDR, Kandivali (E), Mumbai, organized the annual technical festival VISTA-2025 themed on Qala Innovista on 20-21 February 2025 in association with CSI, Mumbai Chapter." },
                    { h3: "Inauguration & Milestone", p: "VISTA 2025 marked the 20th anniversary of the institute's intercollegiate festival, inaugurated by distinguished guests including Dr. Suresh Shan (CSI Chairperson), Mr. Deepak Agarwal (IT Consultant), and Mr. Kripashankar Chaube (Director, Kaltech Digital Pvt. Ltd.)." }
                ],
                images: []
            },
            {
                header: { year: "CSI-TechNext 2024", title: "India Academia Awards" },
                sections: [
                    { h3: "Conference & Recognition", p: "CSI-E-TechNext 2024 Annual Industry and Academia Conference and Awards took place at D. Y. Patil Deemed-to-be University Campus, Nerul, Navi Mumbai on 30-31 August 2024, recognizing the very best in Academics across 2022-2024." },
                    { h3: "TIMSCDR Awards", p: "TIMSCDR received: Best Institute - Innovative Pedagogical Approaches and Tools; Best Principal of the Year - Dr. Vinita Gaikwad; Best HOD of the Year - Mr. Shirshendu Maitra; Best Faculty - Published Research (papers accepted in high-ranking/indexed journals) - Dr. Padma Mishra." }
                ],
                images: []
            },
            {
                header: { year: "CDC 2025", title: "College Development Committee" },
                sections: [
                    { h3: "Meeting & Presence", p: "CDC meeting held on Saturday, March 15, 2025, with the presence of Dr. Suresh Shan, Chairman, CSI-Mumbai Chapter." },
                    { h3: "Key Suggestions", p: "Suggestions included: covering student and faculty research paper publications under CSI-IEEE; CSI support to connect Industry Experts to teach 20% of syllabus under Track Elective courses; involvement of Industry Experts in setting Institute policies." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_6_CDC-CSI.webp"
                ]
            }
        ]
    },
    {
        yearKey: "2023-2024",
        cards: [
            {
                header: { year: "FDP 2024", title: "Microsoft Power BI Training" },
                sections: [
                    { h3: "Data Analytics & Visualization", p: "TIMSCDR organized two days Faculty Development Program (FDP) on 17th and 18th January, 2024 on Microsoft Power BI in association with FOSLIPY and CSI, Mumbai Chapter." },
                    { h3: "Expert Training", p: "Ms. Supriya Thorat, Technical Team Lead, Power BI Developer, delivered sessions covering Data Importation, Transformation, and Basic Modeling with Power BI Desktop." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_9_23-1.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_10_23-2.webp"
                ]
            },
            {
                header: { year: "E-Day 2024", title: "Women Entrepreneurship" },
                sections: [
                    { h3: "Entrepreneurship & Innovation", p: "The Entrepreneurship Day and Institute Innovation Cell (IIC) poster presentation event organized by Ayan E-Cell of TIMSCDR in association with CSI, Mumbai Chapter on March 22, 2024 honored the achievements of women entrepreneurs." },
                    { h3: "Guests of Honour", p: "Shwetha Ashok (Nutritionist and Gut Guru); Krupa Joshi (Proprietor, DigiMark5); Gunjan Pai (Founder of Copylove, Copywriter & Branding Specialist, TEDx)." }
                ],
                images: []
            },
            {
                header: { year: "STTP 2024", title: "ISTE Approved Training Program" },
                sections: [
                    { h3: "Program & Theme", p: "TIMSCDR conducted a 2-week ISTE approved Short Term Training Program (STTP) in association with CSI, Mumbai Chapter from June 18-29, 2024. The theme was Information Technology - Women Empowerment." }
                ],
                images: []
            },
            {
                header: { year: "SYNAPSE 2023-24", title: "IT for Women Empowerment" },
                sections: [
                    { h3: "Innovation Showcase", p: "SYNAPSE provided an opportunity for students to showcase innovative ideas and technical projects to industry experts under the theme Using Information Technology for Women Empowerment." },
                    { h3: "Curtain Raiser", p: "Organized on May 24, 2023 with 16 innovative project ideas from first-year students." },
                    { h3: "Final Presentation & Judges", p: "Final presentation took place on October 12, 2023. The Tenth volume of SYNAPSE - Innovation Magazine was released by judges: Dr. Suresh A. Shan; Mr. Harsha Udupi; Mr. Sanjiv Viswanathan; Mr. A. Siju Rawther; Mr. Mayank Parekh; Mr. Sachit Kumar; Mr. Om Narayan Shukla." }
                ],
                images: []
            },
            {
                header: { year: "VISTA 2024", title: "YUVOTSAV - 19th Anniversary" },
                sections: [
                    { h3: "Grand Celebration", p: "VISTA 2024 marked the 19th anniversary of TIMSCDR's intercollegiate festival, showcasing a vibrant tapestry of student talent and innovation under the YUVOTSAV theme." },
                    { h3: "Dates & Inauguration", p: "Held on April 4-5, 2024 at the TEG campus; inaugurated by Mr. Khushaal Pawar, a content creator, singer, and composer." }
                ],
                images: []
            },
            {
                header: { year: "Guest Lectures", title: "Knowledge & Innovation" },
                sections: [
                    { h3: "IPR & IP Management", p: "Guest lecture on IPR and IP Management for Start-ups in association with CSI on Tuesday, April 02, 2024 by Mr. Janaksinh Jhala, Principal Associate at Khitan & Co." },
                    { h3: "Indian Knowledge System", p: "Guest lecture on Indian Knowledge System on Tuesday, April 02, 2024 by Dr. Seema Jagtap and Ms. Priyanka Deshmukh, exploring India's rich heritage and knowledge systems." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_8_Guest_session_IPR.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_7_Guest_sesion_IKS.webp"
                ]
            }
        ]
    },
    {
        yearKey: "2022-2023",
        cards: [
            {
                header: { year: "STTP 2023", title: "ISTE Approved Training Program" },
                sections: [
                    { h3: "Program & Theme", p: "TIMSCDR conducted a 2-week ISTE approved Short Term Training Program (STTP) in association with CSI, Mumbai Chapter from May 29, 2023 - June 9, 2023. The theme was Information Technology - Women Empowerment." }
                ],
                images: []
            },
            {
                header: { year: "FDP 2023", title: "Robotic Process Automation" },
                sections: [
                    { h3: "Two-Day FDP", p: "TIMSCDR organized a two-day Faculty Development Program (FDP) on 25th and 26th May, 2023 on Robotic Process Automation (RPA) in association with FOSLIPY and CSI, Mumbai Chapter." },
                    { h3: "Expert Session", p: "Delivered by Mr. Durvesh Bendale (Advanced Certified RPA Developer), covering how repetitive computer-oriented human tasks and end-to-end procedures can be automated using RPA." }
                ],
                images: []
            },
            {
                header: { year: "ICAIM 2023", title: "International Conference" },
                sections: [
                    { h3: "Conference & Theme", p: "ICAIM 2023 was held on 11-12 February 2023. Theme: Leveraging Information Technology for Sustainability in Agriculture and Healthcare - Carbon Neutrality." },
                    { h3: "Associations & Participation", p: "Organized in association with CSI, Mumbai Chapter, AMC, MACCIA, and NCSH; eminent personalities from IT, Agriculture, and Medicine participated." }
                ],
                images: []
            },
            {
                header: { year: "DLLE 2023", title: "Poster Making Competition" },
                sections: [
                    { h3: "Themes & Schedule", p: "Offline poster competition held on 11 January 2023 on My Right of Voting in Election and Women Empowerment." }
                ],
                images: []
            },
            {
                header: { year: "SYNAPSE 2022", title: "Innovation Showcase" },
                sections: [
                    { h3: "Theme & Evaluation", p: "SYNAPSE-2022 themed Turning Digital technology innovation into climate action - Carbon Neutrality (UN Goal 13 - Climate Action). Final Presentation on 11th October, 2022 featured online pitches evaluated on Innovation, Creativity, Technical and Socio-Economic Feasibility, Marketing Skills & Team Work." },
                    { h3: "Judges & Recognition", p: "The Ninth volume of SYNAPSE - Innovation Magazine was released by judges including Dr. Suresh A. Shan and Mr. Arvind Prabhu, alongside other industry mentors who evaluated projects and awarded the best entries with cash prizes." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_11_synapse-22-2.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_12_synapse-22.webp"
                ]
            },
            {
                header: { year: "VISTA 2023", title: "Intercollegiate Festival" },
                sections: [
                    { h3: "Techtopia Theme", p: "VISTA 2023 (18th year) was organized on 18th April 2023 at TIMSCDR campus in association with CSI, Mumbai Chapter; a platform showcasing student creativity and networking." },
                    { h3: "Inauguration", p: "Inaugurated by Adv. Ramaswamy Seshan (Co-Founder Partner, Vankawala & Ramaswamy Law Firm) and Ms. Ritu Advani (Founder, Avinya Kendra; former President, Giants Group of Mumbai ONE; National Secretary, Chamber for Innovators & Entrepreneurs in India)." }
                ],
                images: []
            },
            {
                header: { year: "E-Day 2023", title: "Entrepreneurship Day" },
                sections: [
                    { h3: "Objective & Guests", p: "Organized on April 20, 2023 in association with CSI, Mumbai Chapter to instill entrepreneurship via industry experts. Guests of Honour: Ms. Jyoti Agarwal (Founder, Maa2Mom); Mr. Nishit Shah (Engineer, Industrialist & Entrepreneur); Ms. Veena Srivastava (Neuron Consultant, Shercon Designs & indi Granite, CFO)." },
                    { h3: "Activities", p: "Events included Shark Tank, Human Tic-Tac-Toe, Business Quiz, Logo Quest, Big Bull vs Giant Bear, Shayari, and Traditional Day celebration." }
                ],
                images: []
            }
        ]
    },
    {
        yearKey: "2021-2022",
        cards: [
            {
                header: { year: "STTP 2022", title: "ISTE Approved Training Program" },
                sections: [
                    { h3: "Program & Theme", p: "TIMSCDR conducted a 2-week ISTE approved STTP in association with CSI, Mumbai Chapter from 6-17 June 2022 on the theme Information Technology for Sustainability - Carbon Neutrality." },
                    { h3: "Sessions & Takeaways", p: "Across 10 days, industry and academic experts conducted sessions on AWS Cloud, IT for sustainability in Carbon Sequestration and Carbon Neutrality, and non-technical wellbeing topics such as Yoga for Holistic Development, Mindfulness, and Art of Living." }
                ],
                images: []
            },
            {
                header: { year: "VISTA 2022", title: "Technical & Cultural Festival" },
                sections: [
                    { h3: "Festival & Theme", p: "The annual Technical-cum-Cultural Festival VISTA 2022 was organized on 20 April 2022 on the theme Invincible - Immortality of Technology." },
                    { h3: "Inauguration", p: "Inaugurated by Dr. Suresh A. Shan (Head - Digital Innovation & Future Technology, Mahindra & Mahindra Financial Services Ltd.) and Dr. Vinita Gaikwad (Director, TIMSCDR)." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_15_VISTA-20-APRIL-2022-04-19-at-12.03.36-PM.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_16_VISTA-2022-banner.webp"
                ]
            },
            {
                header: { year: "E-Day 2022", title: "Entrepreneurship Day" },
                sections: [
                    { h3: "Event Focus", p: "Annual E-Day 2022, organized by E-Cell on 22 April 2022, promoted entrepreneurship among students." },
                    { h3: "Panel Discussion", p: "Panel on Entrepreneurship as Career Opportunity in Aatmanirbhar Bharat featured panelist Mr. Arvind Prabhu (Founder, Racenext Technology Solutions)." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_17_DSC01009.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_18_DSC01041.webp"
                ]
            },
            {
                header: { year: "SIP 2022", title: "Student Induction Program" },
                sections: [
                    { h3: "CSI & Emerging Tech", p: "As part of SIP, on 6 January 2022 at 10:30 AM, Dr. Suresh Shan (President, CSI-Mumbai Chapter; CTO, Mahindra Finance) delivered a session on CSI and industry skill demands post-COVID, covering Vision Industry 4.0 and E-Business in India." },
                    { h3: "Innovation Examples", p: "He discussed innovations such as 3D printers, Autonomous Vehicles, AI and IoT for security, mobility platforms, and professional behaviors in academic and industry contexts." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_19_WhatsApp-Image-2021-12-24-at-16.26.52.webp"
                ]
            },
            {
                header: { year: "Guest Lecture", title: "Graphology & Handwriting" },
                sections: [
                    { h3: "Expert & Credentials", p: "On 25 November 2021, in association with CSI, Mumbai Chapter, a lecture on Graphology: The Case Study on Handwriting was delivered by Nirav Vasa, a Certified Forensic Handwriting Verification Expert and Certified Graphologist with 18 years experience." },
                    { h3: "Key Insights", p: "Covered handwriting/brain prints, fixed vs. unfixed traits, facets of personality, and physical/attitudinal/emotional aspects; the interactive session demonstrated personality insights from signatures and writing." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_20_2021-11-25.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_21_CSI-25.11.2021.webp"
                ]
            },
            {
                header: { year: "Guest Lecture", title: "Incident Response in Cyber Security" },
                sections: [
                    { h3: "Topic & Speaker", p: "On 16 October 2021, in association with CSI, Mumbai Chapter, Ms. Shweta Trpathi (InfoSec Practitioner & Cyber Security expert) delivered a session on Incident Response in Cyber Security." },
                    { h3: "Coverage & Relevance", p: "Discussed cybersecurity frameworks, attack life cycle, incident response life cycle, real-world breaches (e.g., malware), practical impacts, and password hygiene." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_22_2021-10-16.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_23_CSI-16.10.21.webp"
                ]
            }
        ]
    },
    {
        yearKey: "2020-2021",
        cards: [
            {
                header: { year: "FDP 2021", title: "Blockchain & Advanced Java" },
                sections: [
                    { h3: "Two-Day Online FDP", p: "In association with CSI, Mumbai Chapter, an online FDP was organized between 15-16 January 2021 themed Blockchain & Advanced Java, introducing faculty to multiple technologies." },
                    { h3: "Day 1: Blockchain", p: "Covered Blockchain foundations, features, Bitcoin usage with hands-on, and an introduction to Solidity programming." },
                    { h3: "Day 2: Full-Stack & Java", p: "Faculties learned Angular and Node.js with hands-on execution, and were introduced to the Java Spring Framework." },
                    { h3: "Outcome", p: "Participants reported a rich learning experience and practical exposure across blockchain and modern application development." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_24_image001.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_25_image003.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_26_image005.webp"
                ]
            },
            {
                header: { year: "Guest Lecture", title: "Preventing Cyber Attacks in Pandemics" },
                sections: [
                    { h3: "Speaker & Context", p: "A lecture by Mr. Smith Gonsalves, one of India's youngest Cyber Security evangelists and Information Security professional, Advisor to MitKat Advisory Services and Technical Advisor for The Indian ISAC, arranged in association with CSI, Mumbai Chapter." },
                    { h3: "Focus Areas", p: "Explored remote work's impact on cybersecurity, trust, and data protection; COVID-19 accelerated the need to confront digital preparedness against cyber threats." },
                    { h3: "Engagement", p: "The interactive session was well-received by students for its practical relevance and actionable guidance." }
                ],
                images: [
                    "/images/Life/Professional_Bodies/CSI/imgi_27_01-Preventing-Cyber-attack-CSI-21.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_28_02-Preventing-Cyber-attack-CSI-21.webp",
                    "/images/Life/Professional_Bodies/CSI/imgi_29_03-Preventing-Cyber-attack-CSI-21.webp"
                ]
            },
            {
                header: { year: "SYNAPSE 2020-21", title: "Mentored Innovation" },
                sections: [
                    { h3: "Mentorship & Timeline", p: "CSI Mumbai Chapter members Dr. Suresh Shan and Mr. Arbind Prabhu mentored student projects at SYNAPSE-2020, commencing in August 2020 and concluding on 30 January 2021." }
                ],
                images: []
            }
        ]
    }
];

const galleryItems = [
    { id: 1, src: "/images/Life/Professional_Bodies/CSI/imgi_30_01-technext-2019-scaled.webp", desc: "CSI TechNext Awards" },
    { id: 2, src: "/images/Life/Professional_Bodies/CSI/imgi_46_02-CSI-award-2018.webp", desc: "CSI Awards Recognition" },
    { id: 3, src: "/images/Life/Professional_Bodies/CSI/imgi_58_01-SYNAPSE-2015-scaled.webp", desc: "SYNAPSE Innovation Event" },
    { id: 4, src: "/images/Life/Professional_Bodies/CSI/imgi_40_01-infocom-2018-scaled.webp", desc: "Infocomm India Event" }
];

const Icons = {
    Trophy: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
            <path d="M4 22h16" />
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
        </svg>
    ),
    Principal: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    HOD: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
            <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
    ),
    Book: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
    )
};

const awards = [
    { icon: <Icons.Trophy />, title: "Best Institute – Innovative Pedagogical Approaches and Tools", desc: "TIMSCDR" },
    { icon: <Icons.Principal />, title: "Best Principal of the year", desc: "Dr Vinita Gaikwad" },
    { icon: <Icons.HOD />, title: "Best HOD of the year", desc: "Mr Shirshendu Maitra" },
    { icon: <Icons.Book />, title: "Best Faculty – Published Research", desc: "High-ranking/indexed journals – Dr Padma Mishra" }
];

export default function CSITimsCdr() {
    const [activeYear, setActiveYear] = useState(yearsData[0].yearKey);
    const [showForm, setShowForm] = useState(false);

    const yearOptions = useMemo(() => yearsData.map((y) => y.yearKey), []);

    return (
        <>
            <Navbar setShowForm={setShowForm} />
            <PageHeader
                title="CSI-TIMSCDR"
                crumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'CSI-TIMSCDR ', href: '#' }
                ]}
            />
            {showForm && <BrochureForm setShowForm={setShowForm} />}
            <CTAButtons />
            <div className="ieeeTims_wrapper">

                <div className="ieeeTims_section" id="about">
                    <div className="ieeeTims_sectionTitlePrimary">CSI-TIMSCDR</div>
                    <div className="ieeeTims_paragraph">
                        CSI offers a range of services and networking opportunities through workshop seminars, conventions and careers participated by industry experts sharing best practices and digital opportunities for development, exchanging knowledge and ideas. Topics include emerging technology trends including Service Industry, business, research, and operational achievements.
                    </div>
                </div>

                <div className="ieeeTims_section" id="events">
                    <div className="ieeeTims_sectionTitle">Our Events &amp; Initiatives</div>

                    <div className="ieeeTims_yearTabs" role="tablist">
                        {yearOptions.map((yk) => (
                            <button
                                key={yk}
                                role="tab"
                                aria-selected={activeYear === yk}
                                className={`ieeeTims_tabBtn${activeYear === yk ? " ieeeTims_tabActive" : ""}`}
                                onClick={() => setActiveYear(yk)}
                                onKeyDown={(e) => {
                                    const idx = yearOptions.indexOf(activeYear);
                                    if (e.key === "ArrowLeft" && idx > 0) setActiveYear(yearOptions[idx - 1]);
                                    if (e.key === "ArrowRight" && idx < yearOptions.length - 1) setActiveYear(yearOptions[idx + 1]);
                                }}
                            >
                                {yk}
                            </button>
                        ))}
                    </div>

                    {yearsData.map(({ yearKey, cards }) => (
                        <div
                            key={yearKey}
                            className={`ieeeTims_tabPanel${activeYear === yearKey ? " ieeeTims_tabShow" : ""}`}
                        >
                            <div className="ieeeTims_eventGrid">
                                {cards.map((card, idx) => (
                                    <div key={idx} className="ieeeTims_eventCard">
                                        <div className="ieeeTims_eventTitle">{card.header.year} — {card.header.title}</div>
                                        {card.sections.map((sec, i) => (
                                            <div key={i}>
                                                <div className="ieeeTims_eventMeta">{sec.h3}</div>
                                                <div className="ieeeTims_eventDescription">{sec.p}</div>
                                            </div>
                                        ))}

                                        {card.images && card.images.length > 0 && (
                                            <div className="ieeeTims_gallery" style={{ maxHeight: '1000px', marginTop: '15px' }}>
                                                {card.images.map((imgSrc, imgIdx) => (
                                                    <div key={imgIdx} className="ieeeTims_imageWrapper">
                                                        <img src={imgSrc} alt={`${card.header.title} ${imgIdx + 1}`} loading="lazy" />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="ieeeTims_section ieeeTims_bgLight" id="awards">
                    <div className="ieeeTims_sectionTitle">CSI-TechNext India Academia Award</div>
                    <div className="ieeeTims_paragraph">
                        CSI-E-TechNext 2024 Annual Industry and Academia Conference and Awards took place at D. Y. Patil, deemed to University Campus, Nerul, Navi Mumbai on 30th &amp; 31st August 2024, recognizing excellence across College, Principal, Professor &amp; HOD, TPO, and student projects for contributions from 2022 to 2024.
                    </div>
                    <div className="ieeeTims_facultyGrid">
                        {awards.map((a, i) => (
                            <div key={i} className="ieeeTims_facultyCard">
                                <div style={{ marginBottom: "15px", color: "var(--tm-primary)", display: "flex", alignItems: "center" }}>
                                    {a.icon}
                                </div>
                                <div className="ieeeTims_facultyName">{a.title}</div>
                                <div className="ieeeTims_facultyRole">{a.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="ieeeTims_section">
                    <div className="ieeeTims_sectionTitle">Event Gallery</div>
                    <div className="ieeeTims_eventImages">
                        {galleryItems.map((item) => (
                            <div key={item.id} className="ieeeTims_imgCont">
                                <img src={item.src} alt={item.desc} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
}